import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { AgendaPanel } from "@/client/modules/agenda/agenda-panel";
import Loading from "@/client/modules/agenda/loading";

type Search = { day?: string; doctorId?: string; view?: string; week?: string };

export const Route = createFileRoute("/app/agenda")({
  validateSearch: (s: Record<string, unknown>): Search => ({
    day: s.day as string | undefined,
    doctorId: s.doctorId as string | undefined,
    view: s.view as string | undefined,
    week: s.week as string | undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("agenda", "page", deps)),
  head: () => pageHead("Agenda"),
  pendingComponent: Loading,
  component: AgendaPage,
});

function AgendaPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("agenda", "page", search);
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Agenda" description="Agendamentos do dia." />
      {data.empty ? (
        <div className="rounded-xl border border-slate-200 bg-white p-6 text-sm text-slate-500">
          Nenhum profissional cadastrado no sistema ainda.
        </div>
      ) : (
        <AgendaPanel {...data} />
      )}
    </div>
  );
}
